module.exports = __webpack_public_path__ + "assets/images/albom5.b5b050a9.jpg";